import InternalTopbar from '../../internal/shared/internal_topbar.js.jsx';

export default InternalTopbar;
